var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageIllo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72,
  viewBox: "0 0 72 72",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DDE5EB",
  fillRule: "nonzero",
  d: "M58.8.951c1.702-.251 3.32.846 3.662 2.496l.032.178 8.925 55.569c.276 1.686-.834 3.292-2.521 3.661l-.183.035-56.072 8.98a3.24 3.24 0 0 1-3.687-2.49l-.035-.182L-.004 13.63c-.275-1.686.834-3.292 2.522-3.662l.183-.034zm-4.152 9.658L9.666 17.802l7.121 44.581 10.535-14.52a3.33 3.33 0 0 1 3.508-1.243l.193.058 4.6 1.496 10.25-16.24a3.32 3.32 0 0 1 4.512-1.062l.165.108 8.294 5.747zM23.891 22.063a6.997 6.997 0 0 1 8.008 5.818 7.003 7.003 0 0 1-5.82 8.01 6.997 6.997 0 0 1-8.007-5.818 7.003 7.003 0 0 1 5.82-8.01"
})));
export default SvgImageIllo;